function dobbleGame(conf){
    conf=$.extend(true,{
        girl_id:1,
        conf:{
            "pos_cur":[640,200],
            "pos_own":[640,560],
            "pos_enemy":[1050,560],
            "pos_button_premium":[360,670],
//            "pos_cur":[760,200],
//            "pos_own":[520,560],
//            "pos_enemy":[1050,560],
        },
        game:{
            set_id:1,
            card_max:1,
            card_max_real:1,
            own_howlong:14000,//6000 premium
            enemy_howlong:4000,
            "random_enemy":[90,100],
            "random_own":[100,100],
            bonus1:0,
            bonus2:0
        },
        mark:{
            "own":{color:0xBFFF5E,pos:[80,150],"line_img":"mark_line_own"},
            "enemy":{color:0xFF0000,pos:[1280-80,150],"line_img":"mark_line_enemy"}
        },
        langs:{
            "card_own":"",
            "card_cur":""
        },
        onLoad:function(){},
        onScore:function(){},
        onFail:function(){},
        onEnd:function(is_win){},
        onMoveEnd:function(){},
        onUpdateState:function(state){}
    },conf);
    this.conf=conf;
    this.resources={};
    this.app;
    this.appHelp;
    this.allLayers=new PIXI.Container();
    this.gameLayers={
        "girls":new PIXI.Container(),
        "texts":new PIXI.Container(),
        "cards":new PIXI.Container()
        
    };
    this.girlObj={"own":{},"enemy":{}};
    this.girlControl={"own":{},"enemy":{}};
    
    this.gameState={
        show_hint:0,//girl show you answer
        blocked:0,//can play card
        win_id:0,//1-user,2-enemy
        cards:{own:0,enemy:0}
    };
    
    var thc=this;
    this.gameLayers.cards.updateLayersOrder = function () {
        thc.gameLayers.cards.children.sort(function(a,b) {
            a.zIndex = a.zIndex || 0;
            b.zIndex = b.zIndex || 0;
            return a.zIndex - b.zIndex;
        });
    };
    this.allLayers.updateLayersOrder = function () {
        return false;
        thc.allLayers.children.sort(function(a,b) {
            a.zIndex = a.zIndex || 0;
            b.zIndex = b.zIndex || 0;
            return a.zIndex - b.zIndex;
        });
    };
    this.gameLayers["girls"].updateLayersOrder = function () {
        thc.gameLayers["girls"].children.sort(function(a,b) {
            a.zIndex = a.zIndex || 0;
            b.zIndex = b.zIndex || 0;
            return a.zIndex - b.zIndex;
        });
    };
    this.cardsAll={move:[]};//own,cur,move,enemy
    this.cardsConf=[[],[]];
    
    this.wrap_div;
    this.was_started=0;
    
    this.markCell=new myPixiElement.container({});
    this.markCell.zIndex=2;
    this.markCell.alpha=0;
    this.gameLayers.cards.addChild(this.markCell);
    
   
    
    
//    myPixiObj.showText=function(txt,conf)
//    
//    
//    pos:[0,0],
//        font_color:"#000000",
//        font_size:25,
//        border_color:"",
//        border_size:0,
//        step_max:0,
//        step_max_fadeout:0,
//        font_family: "Montserrat",
//        onUpdate:undefined,
//        anchor:[0.5,0.5]
}
dobbleGame.prototype={
    initBackground:function(wrap_div){
        var thc=this;
        this.wrap_div=wrap_div;
        this.app = new PIXI.Application({
            width: 1280, height: 780,antialias: true,transparent:true,
            view:wrap_div.find("canvas")[0]
        });
        var i;
        
        this.app.stage.addChild(this.allLayers);
        for(i in this.gameLayers){
            this.allLayers.addChild(this.gameLayers[i]);
        }
        
        var app=this.app;
        _moduleEvents.one("moduleClear",function(){
            if(typeof app!="undefined" && typeof app.destroy!="undefined"){
                try{
                    app.destroy();
                }
                catch(e){}
            }
        });
        
        this.girlObj["own"]=new dobbleGameGirl(this.conf.girl_id,this.resources,{
            onHit:function(){
                _moduleEvents.trigger("dobblesound","hit");
                thc.girlObj["enemy"].qAnim("hit");
                thc.girlObj["enemy"].handleAttach(thc.gameState.cards.own);
            },
            val_max:this.conf.game.card_max_real
        });
        this.girlObj["enemy"]=new dobbleGameGirl(0,this.resources,{
            onHit:function(){
                _moduleEvents.trigger("dobblesound","hit");
                thc.girlObj["own"].qAnim("hit");
                thc.girlObj["own"].handleAttach(thc.gameState.cards.enemy);
            },
            val_max:this.conf.game.card_max_real
        });
        
        for(i in this.girlObj){
            this.gameLayers["girls"].addChild(this.girlObj[i]);
            this.girlObj[i].handleAttach(this.conf.game.card_max);
            this.girlObj[i].fadeIn(20);
        }
        
        
        this.app.ticker.add(
            function(delta){thc.gameLoop(delta);}    
        );
        this.markCell.shape=new myPixiElement.img({img:"mark_cell"});
        this.markCell.addChild(this.markCell.shape);
    },
    initGame:function(){
        
        
        this.prepareDeck();
        
        
        
        
        if(this.conf.game.bonus2){
            this.bonusButton=new myPixiElement.img({img:"but_premium"});
            this.bonusButton.zIndex=5;
            this.bonusButton.x=this.conf.conf["pos_button_premium"][0];
            this.bonusButton.y=this.conf.conf["pos_button_premium"][1];
            this.gameLayers["girls"].addChild(this.bonusButton);
        }
        this.addTexts();
    },
    addTexts:function(){
        this.gameLayers.texts.addChild(
            new myPixiObj.showText(this.conf.langs.card_own,{
                font_color:"#ffffff",
                border_color:"#000000",
                border_size:2,
                anchor:[0.5,1],
                pos:[this.conf.conf.pos_own[0],this.conf.conf.pos_own[1]+190]
            })
        );
        this.gameLayers.texts.addChild(
            new myPixiObj.showText(this.conf.langs.card_cur,{
                font_color:"#ffffff",
                border_color:"#000000",
                border_size:2,
                anchor:[0.5,1],
                pos:[this.conf.conf.pos_cur[0],this.conf.conf.pos_cur[1]+190]
            })
        );
    },
    initHowto:function(wrap_div,onMatch){
        var app = new PIXI.Application({
            width: 670, height: 340,antialias: true,transparent:true,
            view:wrap_div.find("canvas")[0]
        });
        function delApp(){
            if(typeof app!="undefined" && typeof app.destroy!="undefined"){
                try{
                    app.destroy();
                }
                catch(e){}
            }
        }
        _moduleEvents.one("moduleClear",function(){
            delApp();
        });
        var mainCointainer=new PIXI.Container();
        app.stage.addChild(mainCointainer);
        var deckObj=new dobbleSet();
        var deckArr=deckObj.takeDeck(1);
        array_shuffle(deckArr);
        var objArr=[];
        var i;
        var cardConf,qConf;
        var initConf=[
            {pos:[169,170]},
            {pos:[501,170]}
        ];
        for(i=0;i<2;i++){
            cardConf=deckArr.shift();
            qConf=initConf[i];
            objArr[i]=new dobbleGameCell({
                imgConf:cardConf,
                pos:qConf.pos,
            },this.resources);
            objArr[i].init();
            mainCointainer.addChild(objArr[i]);
        }
        var img_id=objArr[0].findCommon(objArr[1]);
        objArr[0].markImage(img_id);
        objArr[1].markImage(img_id);
        
        this.app.ticker.add(
            function(delta){
                for(i=0;i<2;i++){
                    objArr[i].myUpdate(delta);
                }
            }    
        );
        function clickGhost(pos){
            
            var i,i_op,img_id;
            for(i=0;i<2;i++){
                i_op=(i+1)%2;
                img_id=objArr[i].checkClick(pos);
                if(img_id>-1){
                    if(objArr[i_op].haveImage(img_id)){
                        delApp();
                        onMatch();
                    }
                    else{
                        objArr[i].wrongImage(img_id);
                    }
                }
            }
        }
        
        new addTouch(wrap_div.find(".qTouchJS")[0],{
            onStart:function(arr){
                clickGhost(arr[0]);
            },
            onMouseDown:function(arr){
                clickGhost(arr[0]);
            }
        });
        
    },
    score:function(img_id){
        if(this.gameState.win_id!=0){
            return false;
        }
        this.gameState.blocked=1;
        this.girlControl.own.clear();
        this.girlControl.enemy.minus();
        this.gameState.show_hint=0;
        this.gameState.cards.own--;
        this.changeState();
        
        var obj=this.cardsAll.own;
        
        this.startMove(this.cardsAll.own,"own");
        
        this.startMarkLine(img_id,"own",obj);
        
        
        this.takeNextCard();
        this.conf.onScore();
        return true;
    },
    fail:function(){
        if(this.gameState.win_id!=0 || !this.enemyPlay()){
            return false;
        }
        this.gameState.cards.enemy--;
        this.girlControl.enemy.clear();
        this.changeState();
        this.conf.onFail();
        return true;
    },
    startMove:function(moveObj,state_str){
        //locked game
        
        this.cardsAll.own.unmarkImage();
        this.cardsAll.cur.unmarkImage();
        moveObj.setZindex(2);
        this.cardsAll.cur.setZindex(1);
        this.gameLayers.cards.updateLayersOrder();
        var thc=this;
        
        moveObj.moveToPos(this.conf.conf["pos_cur"],function(){
            thc.endMove(this.conf.p_id,state_str);
        });
        this.cardsAll.move.push(moveObj);
        
        this.gameLayers["girls"].zIndex=1;
        this.gameLayers["cards"].zIndex=0;
        this.allLayers.updateLayersOrder();
        
        this.girlObj["own"].zIndex=0;
        this.girlObj["enemy"].zIndex=0;
        
        if(this.gameState.blocked==1){
            //own
            this.girlObj["own"].qAnim("punch");
            this.girlObj["own"].zIndex=1;
        }
        if(this.gameState.blocked==2){
            //enemy
            this.girlObj["enemy"].qAnim("punch");
            this.girlObj["enemy"].zIndex=1;
        }
        this.gameLayers["girls"].updateLayersOrder();
    },
    endMove:function(p_id,state_str){
      //unlock game
        var i,obj;
        for(i=this.cardsAll.move.length-1;i>=0;i--){
            obj=this.cardsAll.move[i];
            if(obj.conf.p_id==p_id){
                this.cardsAll.cur.destroy();
                this.cardsAll.cur=obj;
                this.cardsAll.cur.unMarkLine();
                this.cardsAll.move.splice(i,1);
            }
        }
        this.endMarkLine();
        
        this.gameLayers["girls"].zIndex=0;
        this.gameLayers["cards"].zIndex=1;
        this.allLayers.updateLayersOrder();
        
        this.gameState.blocked=0;
        if(this.gameState.show_hint!=0){
            this.markGood();
        }
        if(state_str=="enemy"){
            this.cardsAll.own.unableHide();
        }
        this.conf.onMoveEnd.call(this);
    },
    enemyPlay:function(){
        if(this.gameState.blocked!=0){
            return false;
        }
        this.gameState.blocked=2;
        if(!this.takeEnemyCard()){
            this.gameState.blocked=0;
            return false;
        }
        ;
        var img_id=this.cardsAll.enemy.findCommon(this.cardsAll.cur);
        var img_id_own_old=this.cardsAll.own.findCommon(this.cardsAll.cur);
        if(img_id>-1){
            var obj=this.cardsAll.enemy;
    //        this.girlObj["enemy"].qAnim("put");
    
            this.cardsAll.own.unableShow(img_id_own_old);
            this.cardsAll.cur.unableShow(img_id_own_old);
            this.startMove(this.cardsAll.enemy,"enemy");
            

            this.startMarkLine(img_id,"enemy",obj);
        }
        
        return true;
    },
    startMarkLine:function(img_id,state,obj){
        var conf=this.conf.mark[state];
        obj.markLine(img_id,conf);
        this.cardsAll.cur.markLine(img_id,conf);
//        var cell_size_radius=75;
//        this.markCell.shape
//        .clear()
//        .beginFill(conf.color)
//        .drawCircle(0, 0, cell_size_radius)
//        .endFill()
//        .lineStyle(1,0x000000)
//        .drawCircle(0, 0, cell_size_radius)
//        .endFill();

        var imgObj=new myPixiElement.img({img:"img"+img_id});
        imgObj.scale.set(0.5);
        if(typeof this.markCell.imgObj!="undefined"){
            typeof this.markCell.imgObj.destroy();
        }
        
        this.markCell.addChild(imgObj);
        this.markCell.imgObj=imgObj;

        this.markCell.x=conf.pos[0];
        this.markCell.y=conf.pos[1];
        this.markCell.fadeStop();
        this.markCell.alpha=1;
    },
    endMarkLine:function(){
        this.markCell.fadeOut(100);
    },
    markGood:function(){
        if(this.gameState.win_id!=0){
            return false;
        }
        this.gameState.show_hint=1;
        if(this.gameState.blocked!=0){
            return false;
        }
        var img_id=this.cardsAll.cur.findCommon(this.cardsAll.own);
        this.cardsAll.own.markImage(img_id);
        this.cardsAll.cur.markImage(img_id);
    },
    prepareDeck:function(){
        var deckObj=new dobbleSet();
        var deckArr=deckObj.takeDeck(this.conf.game.set_id);
        array_shuffle(deckArr);
        
        var cardConf=deckArr.shift();
        this.cardsAll.cur=new dobbleGameCell({
            imgConf:cardConf,
            pos:this.conf.conf.pos_cur
        },this.resources);
        this.cardsAll.cur.init();
        this.cardsAll.cur.alpha=0;
        this.gameLayers["cards"].addChild(this.cardsAll.cur);
        var i,i_max=deckArr.length-1,k;
        if(this.conf.game.bonus1){
            i_max-=1;
        }
        
        var need_val=2+intval(this.conf.game.bonus1);
        
        for(i=0;deckArr.length>=need_val && i<this.conf.game.card_max*2;i+=2){
            for(k=0;k<2;k++){
                this.cardsConf[k].push({p_id:(i+k),imgConf:deckArr.shift()});
            }
        }
        if(this.conf.game.bonus1){
            this.cardsConf[1].push({p_id:(i+1),imgConf:deckArr.shift()});
        }
        
        this.gameState.cards.own=this.cardsConf[0].length;
        this.gameState.cards.enemy=this.cardsConf[1].length;
        this.changeState();
        
        this.takeNextCard();
        
        
//        this.markGood();
    },
    takeNextCard:function(){
        if(this.cardsConf[0].length==0){
            this.gameLayers.cards.updateLayersOrder();
            return false;
        }
        var cardConf=this.cardsConf[0].shift();
        
        this.cardsAll.own=new dobbleGameCell({
            p_id:cardConf.p_id,
            imgConf:cardConf.imgConf,
            pos:this.conf.conf.pos_own,
            is_own:1
        },this.resources);
        this.cardsAll.own.init();
        this.gameLayers["cards"].addChild(this.cardsAll.own);
        this.cardsAll.own.setZindex(1);
        
        this.gameLayers.cards.updateLayersOrder();        
    },
    takeEnemyCard:function(){
        if(this.cardsConf[1].length==0){
            this.gameLayers.cards.updateLayersOrder();
            return false;
        }
        var cardConf=this.cardsConf[1].shift();
        
        this.cardsAll.enemy=new dobbleGameCell({
            p_id:cardConf.p_id,
            imgConf:cardConf.imgConf,
            pos:this.conf.conf.pos_enemy,
            is_own:1
        },this.resources);
        this.cardsAll.enemy.init();
        this.gameLayers["cards"].addChild(this.cardsAll.enemy);
        this.cardsAll.own.setZindex(1);
        
        this.gameLayers.cards.updateLayersOrder();    
        return true;
    },
    changeState:function(){
        var res={win_id:0,cards:{own:20,enemy:20}};
        if(this.gameState.win_id==0){
            if(this.gameState.cards.own==0){
                this.gameState.win_id=1;
            }
            else if(this.gameState.cards.enemy==0){
                this.gameState.win_id=2;
            }
        }
        
        res.win_id=this.gameState.win_id;
        res.cards=this.gameState.cards;
        this.conf.onUpdateState(res);
        if(this.gameState.win_id>0){
            this.endGame();
        }
    },
    endGame:function(){
        this.gameLayers.texts.alpha=0;
    },
    initDev:function(){
        var setObj=new dobbleSet();
        var set_id=3;
        
        var set_arr=setObj.takeSet(set_id);
        var arr_id,obj;
        var arr_need_ids=[ 
              
        ];
        for(arr_id in set_arr){
            arr_id=intval(arr_id);
            if(arr_need_ids.length==0 || in_array(arr_id,arr_need_ids)){
            
                obj=new dobbleGameCell({
                    set_id:set_id,
                    arr_id:intval(arr_id),
                    imgArr:setObj.takeSet(set_id)[arr_id]
                },this.resources);
                obj.init();
            }
        }
        
        this.gameLayers[0].addChild(obj);
        
        
    },
    
    startLoader:function(){
        var thc=this;
        var loaderMain = new PIXI.loaders.Loader();
        var img_other={
            "cell_back":_IMG_SERV+"/gfx/place/dobblegame/game/ui/circle.png",
            "but_premium":_IMG_SERV+"/gfx/place/dobblegame/game/ui/premium_but.png",
            "girl_own":_IMG_SERV+"/gfx/place/dobblegame/game/girls/"+$.takeGirlImage(this.conf.girl_id)+"/skeleton.json",
            "girl_enemy":_IMG_SERV+"/gfx/place/dobblegame/game/girls/pillow/skeleton.json",
            "mark_line_enemy":_IMG_SERV+"/gfx/place/dobblegame/game/ui/line_red.png?2",
            "mark_line_own":_IMG_SERV+"/gfx/place/dobblegame/game/ui/line_green.png?2",
            "mark_cell":_IMG_SERV+"/gfx/place/dobblegame/game/ui/circle_ins_min.png",
            "mark_cell_un":_IMG_SERV+"/gfx/place/dobblegame/game/ui/red_border.png",
            "mark_cell_red":_IMG_SERV+"/gfx/place/dobblegame/game/ui/mark_red.png",
            "mark_cell_green":_IMG_SERV+"/gfx/place/dobblegame/game/ui/mark_green_one.png",
            "mark_wrong":_IMG_SERV+"/gfx/place/dobblegame/game/ui/wrong.png"
        };
        var i;
        for(i=1;i<=57;i++){
            loaderMain.add("img"+i,_IMG_SERV+"/gfx/place/dobblegame/game/img/"+i+".png");
        }
        for(i in img_other){
            loaderMain.add(i,img_other[i]);
        }
        
        loaderMain.load(function(loader, r){
            var i;
            for(i in r){
                thc.resources[i]=r[i];
            }
            thc.conf.onLoad.call(thc);
        });
        
        _moduleEvents.one("moduleClear",function(){
            if(typeof loaderMain.reset!="undefined"){
                loaderMain.reset();
            }
        });
    },
    start:function(){
        var thc=this;
        this.girlControl={"own":{},"enemy":{}};
        this.girlControl.own=new dobbleGameControl({
            howlong:this.conf.game.own_howlong,
            howlong_random:this.conf.game.random_own,
            onHit:function(){
                if(thc.gameState.cards.own>1){
                    thc.markGood();
                }
            }
        });
        this.girlControl.own.init();
        this.girlControl.enemy=new dobbleGameControl({
            howlong:this.conf.game.enemy_howlong,
            howlong_random:this.conf.game.random_enemy,
            onHit:function(){
                if(thc.fail()){
                }
            },
            onBonusStart:function(){
                thc.girlObj["enemy"].qAnim("bonus");
            },
            onBonusEnd:function(){
                thc.girlObj["enemy"].restoreForceAnim();
            }
        });
        this.girlControl.enemy.init();
        
        this.cardsAll.cur.fadeIn(15);
        
       

        this.startControl();
        this.was_started=1;
    },
    startControl:function(){
        var thc=this;
        function clickGhost(pos){
            
            if(thc.gameState.blocked==0){
                var img_id=thc.cardsAll.own.checkClick(pos);
                if(img_id>-1){
                    if(thc.cardsAll.cur.haveImage(img_id)){
                        thc.score(img_id);
                    }
                    else{
                        thc.cardsAll.own.wrongImage(img_id);
                        thc.fail();
                    }
                }
                else{
                    img_id=thc.cardsAll.cur.checkClick(pos);
                    if(img_id>-1){
                        if(thc.cardsAll.own.haveImage(img_id)){
                            thc.score(img_id);
                        }
                        else{
                            thc.cardsAll.cur.wrongImage(img_id);
                            thc.fail();
                        }
                    }
                }
                if(thc.conf.game.bonus2){
                    
                    if(thc.bonusButton.containsPoint(new PIXI.Point(pos[0],pos[1]))){
                        
                        
                        thc.conf.game.bonus2=0;
                        thc.bonusButton.alpha=0;
                        
                        thc.girlControl.enemy.forceBonus();
                        
//                        if(thc.conf.game.bonus2==2){
//                            var img_id=thc.cardsAll.own.findCommon(thc.cardsAll.cur);
//                            thc.score(img_id);
//                        }
//                        else{
//                            
//                        }
//                        
//                        thc.conf.game.bonus2=2;
                        
                        
                        
                        
                        
//                        var img_id=thc.cardsAll.own.findCommon(thc.cardsAll.cur);
//                        thc.score(img_id);
                    }
                    
                }
                
                
            }
            
           
            
        }
        new addTouch(this.wrap_div.find(".touchDivJS")[0],{
            onStart:function(arr){
                clickGhost(arr[0]);
            },
            onMouseDown:function(arr){
                clickGhost(arr[0]);
            }
        });
        
        
    },
    gameLoop:function(delta){
        var i,obj;
//        delta=delta/20;
        if(this.was_started==1){
            this.cardsAll.cur.myUpdate(delta);
            this.cardsAll.own.myUpdate(delta);
            for(i=this.cardsAll.move.length-1;i>=0;i--){
                obj=this.cardsAll.move[i];
                obj.myUpdate(delta);
            }
            for(i in this.girlControl){
                this.girlControl[i].add(delta);
            }
        }
        
        for(i in this.girlObj){
            this.girlObj[i].myUpdate(delta);
        }
        this.markCell.myUpdate(delta);
    }
};